import { createFileRoute } from "@tanstack/react-router";
import { AssetAdmin } from "@/components/Assets/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const assetId = params?.id as string;

  return <AssetAdmin assetId={assetId} />;
}

export const Route = createFileRoute("/_authenticated/assets/$id/")({
  component: RouteComponent,
  staticData: { page: ["deals", "banking", "valuations", "tax"] },
});
